import { put, call, getContext, select } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { checkServiceFail, checkServiceStart, checkServiceSuccess } from '../../../reducers/checkoutInfo';
import { checkService as checkServiceRequest } from '../../../../services/checkService';
import { getCheckServiceParams, getPublishTerms } from './utils';
import { IAppState, TActions } from '../../../types';
import { IConfig } from '@cian/config/shared';
import {
  selectActivePackage,
  selectActivePeriod,
  selectActivePlacingType,
  selectActiveRecommendedPackage,
  selectActiveService,
} from '../../../../selectors/publishTerms';
import { selectIsAuctionEnabled } from '../../../../selectors/auction';
import { ITelemetryService } from '../../../../types/telemetryService';
import { SELECT_PUBLISH_TERMS_SERVICE } from '../../../reducers';

export function* checkService(action: TActions) {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');
  const config: IConfig = yield getContext('config');
  const telemetryService: ITelemetryService = yield getContext('telemetryService');
  const state: IAppState = yield select();

  const service: ReturnType<typeof selectActiveService> = yield select(selectActiveService);
  const servicePackage: ReturnType<typeof selectActivePackage> = yield select(selectActivePackage);
  const period: ReturnType<typeof selectActivePeriod> = yield select(selectActivePeriod);
  const placingType: ReturnType<typeof selectActivePlacingType> = yield select(selectActivePlacingType);
  const recommendedPackage: ReturnType<typeof selectActiveRecommendedPackage> = yield select(
    selectActiveRecommendedPackage,
  );
  const isAuctionEnabled: ReturnType<typeof selectIsAuctionEnabled> = yield select(
    selectIsAuctionEnabled,
  );

  const { offer, user, checkoutInfo, auction, calltracking } = state;

  const isServiceChanged = action.type === SELECT_PUBLISH_TERMS_SERVICE;

  yield put(checkServiceStart());

  const terms = getPublishTerms({
    service,
    servicePackage,
    recommendedPackage,
    period,
    placingType,
    auction,
    isAuctionEnabled,
    calltracking,
  });

  const parameters = getCheckServiceParams({
    offer,
    user,
    checkoutInfo,
    terms,
    isServiceChanged,
  });

  const subdomain = config.get<string>('subdomain') || 'www';

  const response = yield call(checkServiceRequest, {
    httpApi,
    logger,
    telemetryService,
    parameters,
    subdomain,
  });

  if (response.success) {
    yield put(checkServiceSuccess(response.payload));
  } else {
    yield put(checkServiceFail(response.payload));
  }
}
